import envConst from '@mixins/const/envConst';

/* MIXINS POUR L'UPLOAD DE FICHIERS (PHOTOS ET DOCUMENTS) */
export default {
  mixins: [envConst],
  computed: {
    acceptOnlyPictures() {
      return '.png, .jpeg, .jpg';
    },
    acceptOnlyPdf() {
      return '.pdf, application/pdf';
    },
    acceptOnlyDocuments() {
      return '.docx' + ', ' + this.acceptOnlyPdf;
    },
    acceptPicturesAndPdf() {
      return this.acceptOnlyPictures + ', ' + this.acceptOnlyPdf;
    },
  },
  methods: {
    getInvalidFileSizeMessage() {
      return this.$t('file.err_size', [this.getMaxFileUploadAsMB()]);
    },
    getInvalidFileTypeMessage(accept) {
      if (!accept || accept.length === 0) return this.$t('file.err_type_basic');
      return this.$t('file.err_type', [accept]);
    },
  },
};
